/* Beacon fetch: one request, the stored Bearer, never a refresh.
   2026-10-18 (issue 2829, U-FETCH9, after U-FETCH0b). fetchWithAuth answers a
   401 with sharedRefresh(), a normal POST. A beacon can share a tick with a
   navigation (Stripe checkout, unload); the navigation can cancel that
   refresh after the server rotated the single-use refresh token, and the rep
   returns signed out. A beacon is best-effort telemetry, so it sends once,
   carries the Bearer when one is stored, and hands back whatever the server
   said, a 401 included. Same shape as the keepalive branch of authFetch in
   wedgeDataBridge.ts. */
import { createRequestId, wedgeAuthHeader } from '@territory/client/api';

export function keepaliveFetch(url: string, init: RequestInit = {}): Promise<Response> {
  const headers = new Headers(init.headers);
  if (!headers.has('X-Request-Id')) headers.set('X-Request-Id', createRequestId());
  const bearer = wedgeAuthHeader().Authorization;
  if (bearer) headers.set('Authorization', bearer);
  return fetch(url, { ...init, headers, credentials: 'include', keepalive: true });
}
